import React, { FC } from 'react';
import { FaRegCalendarPlus } from 'react-icons/fa';

export type AddToMealPlanVariant = 'text' | 'icon';

export interface AddToMealPlanButtonProps {
  /** Called when the user clicks “Add” */
  onClick: () => void;
  /** Choose "text" for full button, "icon" for icon-only */
  variant?: AddToMealPlanVariant;
}

/**
 * A reusable “Add to Meal Plan” button.
 *
 * - variant="text": renders a pill with icon + “Add to Plan” text
 * - variant="icon": renders only the calendar icon in a circle
 */
export const AddToMealPlanButton: FC<AddToMealPlanButtonProps> = ({
  onClick,
  variant = 'text',
}) => {
  if (variant === 'icon') {
    return (
      <button
        onClick={onClick}
        className="p-2 bg-black text-white rounded-tl-lg flex items-center justify-center hover:bg-gray-800 transition"
        aria-label="Add to Meal Plan"
      >
        <FaRegCalendarPlus className="w-4 h-4" />
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      className="
        flex
        items-center
        justify-center    /* ← centers icon + text */
        gap-1
        w-full
        px-3
        py-3
        bg-black
        text-white
        rounded-full
        text-m
        font-medium
        hover:bg-gray-800
        transition
      "
    >
      <FaRegCalendarPlus className="w-4 h-4" />
      Add to Plan
    </button>
  );
};

export default AddToMealPlanButton;
